import {TABS} from "@/utils/task";
import {TAB_MSGS} from "@/utils/comment";

export default {
    isInited: false,
    is403: false,
    is404: false,

    /**
     * New multiple "panel" contexts.
     * Used with panel view mode only so far.
     * Contains array of all contexts opened in panels or an empty array (or null) if no panels opened.
     */
    contexts: null,

    /**
     * Current selected context objects.
     */
    context: {
        item: null, // current context item (group/task/pick/user)
        withFullAccess: false,
        mode: null,
        modeProp: null,
        filterAssigneeId: null,
        filterColor: null,
        selectedTasks: null,
        totalTasks: null,
        parents: null,
        /** Бэкенд рекомендует сразу открыть панель задачи (у контекста-задачи есть детали/комментарии). */
        withTaskPanelRecommended: false,
        /** Бэкенд отдал задачи пользовательского контекста деревом: проект -> папки -> задачи. */
        userTree: false,

        pick: null,
        group: null,
        topic: null,
        tag: null,
        tab: TABS.ACTUAL,

        assignee: null,
        prio: false,
        //search: null,
        usersOfGroup: null,
        isRecent: false,

        TITLE: null,
    },

    /**
     * Actual task list from current context.
     * todo join with context?
     */
    tasks: {
        isInited: false,
        items: null,
        flatItems: null,
        soonItems: null,
        tags: null,
        topics: null,
        //msgs: null,
        //files: null,
    },

    /**
     * Actual task (edited one).
     */
    task: {
        isInited: false,
        isSealed: false,
        isFullAccess: false,

        item: null,
        children: null,
        parents: null,
        related: null,
        navPaths: null,
        contexts: null,
        stages: null,
        files: null,
        events: null,
        templateItem: null,
        templateNavPaths: null,
        assignee: null,
        group: null,
        topic: null,
        command: null,
        timer: null,
        numbers: null,
        subtask: null,

        TITLE: null,
        //siblings: null,
        //totalActualItems: null,

        // subtasks 2.0
        uploads: null
    },

    /**
     * Actual event list for this user (ex notifications).
     * todo join with context/session?
     */
    events: {
        isInited: false,
        items: null,
    },

    deletedTaskAuths: [],

    /*comments: {
        items: null,
        tabId: TAB_MSGS,
    },*/

    comment: {
        item: {
            content: null,
            action: null,
        },
        uploads: null,
    },

    // --- dynamic data from BE --- todo review naming

    uploadResult: {
        files: null,
    },
    // this follows name of mutation
    topicAppend: {
        group: null,
        item: null,
    },
    taskAppend: {
        item: null,
    },
    taskUpdate: {
        item: null,
    },
    tasksUpdate: {
        items: null,
    },
    contextAppend: {
        item: null,
    },
    contextUpdate: {
        item: null,
    },
}